<script>
    import { mapGetters, mapActions } from "vuex";
    import FPageAdminAddCompany from "./FPageAdminAddCompany";

    export default {
        name: "FPageAdmin",

        components: {
            FPageAdminAddCompany
        },

        computed: {
            ...mapGetters(["companySelected", "companies", "companiesFlat"]),

            selectCompany: {
                get() {
                    return this.companySelected.pessoa.nomeFantasia;
                },

                set(name) {
                    const selected = this.companies.find(
                        c => c.pessoa.nomeFantasia === name
                    );

                    if (selected) {
                        this.setCompany(selected);
                    }
                }
            }
        },

        methods: {
            ...mapActions(["setCompany"])
        }
    };
</script>

<template>
    <section class='pa-2'>
        <v-sheet class='mx-auto pa-3 fluid__card'>
            <header class='fluid__card__header'>
                <h4 class='headline'>{{ companySelected.pessoa.nomeFantasia }}</h4>

                <FPageAdminAddCompany/>
            </header>
            <v-select :items='companiesFlat' v-model='selectCompany' label='Empresa selecionada'></v-select>
        </v-sheet>
    </section>
</template>

<style scoped>
    .fluid__card {
        border: 1px solid #ccc;
    }

    .theme--dark.application .fluid__card {
        border-color: #000;
    }

    .fluid__card__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 25px;
    }
</style>

